<template>
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true" :full-screen="true">
    <div class="px-2">
        <div class="row mt-3 d-flex">
            <div class="mb-lg-3 col-md-4 col-sm-6">
                <div class="input-group input-group-sm">
                    <span class="input-group-text col-md-3">Desde</span>
                    <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="startdate" v-model="filter.date_start" @change="mtdShowData" />
                </div>
            </div>
            <div class="mb-lg-3 col-md-4 col-sm-6">
                <div class="input-group input-group-sm">
                    <span class="input-group-text col-md-3">Hasta</span>
                    <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="enddate" v-model="filter.date_end" @change="mtdShowData" />
                </div>
            </div>
            <div class="mb-3 col-md-4 col-sm-12">
                <div class="input-group input-group-sm">
                    <span class="input-group-text text-white bg-main "><i class="fas fa-search"></i></span>
                    <input v-model="search" type="text" class="form-control form-control-sm" placeholder="Buscar por Factura/Boleta" @input="mtdSearchFilter"/>
                </div>
            </div>
            <hr>
            <div v-if="data.length > 0 && cpData.length > 0" class="d-flex justify-content-end pe-5">
                <nav aria-label="Page navigation example ">
                    <ul class="pagination mb-0 ">
                        <li class="page-item">
                            <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                        </li>
                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                        </li>
                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                            <span class="page-link">...</span>
                        </li>

                        <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                            <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                            </a>
                        </li>
                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                            <span class="page-link">...</span>
                        </li>
                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-md-12 mt-3 px-2" v-for="(bill, index) in cpData" :key="index">
                <div class="row d-flex border border-1 border-main px-4 mx-4" style="background-color: #f2f4f4">
                    <div class="col-md-12 mx-1">
                        <div class="row d-flex mt-3 mx-0">
                            <div class="mb-3 col-lg-1 col-md-2 col-sm-2 border border-1 border-secondary bg-main">
                                <span class="me-4 fw-semibold text-white">N°:</span>
                                <span class=" text-white">{{ mtdNumber(index) }}</span>
                            </div>
                            <div class="mb-3 col-lg-2 col-md-4 col-sm-4 border border-1 border-secondary">
                                <span class="me-4 fw-semibold">{{ bill.type == 1 ? 'FACTURA' : (bill.type == 2 && type == 'oc' ? 'BOLETA' : 'RECIBO H.') }}:</span>
                                <span class="">{{ bill.number }}</span>
                            </div>
                            <div class="mb-3 col-md-6 col-sm-6 border border-1 border-secondary" :class="bill.detraction_amount ? 'col-lg-2' : 'col-lg-4'">
                                <span class="me-4 fw-semibold">Total:</span>
                                <span class="">{{ bill.money == "soles" ? 'S/.' : '$.' }} {{ parseFloat(bill.total).toFixed(2) }}</span>
                            </div>
                            <div class="mb-3 col-lg-2 col-md-6 col-sm-6 border border-1 border-secondary" v-if="bill.detraction_amount">
                                <span class="me-4 fw-semibold">Total Detraccion:</span>
                                <span class="">S/. {{ parseFloat(bill.detraction_amount).toFixed(2) }}</span>
                            </div>
                            <div class="mb-3 col-lg-3 col-md-6 col-sm-6 border border-1 border-secondary">
                                <span class="me-4 fw-semibold">Fecha:</span>
                                <span class="">{{ bill.date | formatDate}}</span>

                            </div>
                            <div class="mb-3 col-lg-2 col-md-6 col-sm-6 border border-1 border-secondary">
                                <span class="me-4 fw-semibold">Estado:</span>
                                <span class="">{{ bill.state ==1 ? 'Pagado' : (bill.state == 2 ? 'Pagado Parcealmente' : 'Cerrado') }}</span>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 table-responsive" id="div-tabla-anular">
                        <table id="tb-anular" class="table table-bordered">
                            <caption class="mx-0 px-0"></caption>
                            <thead class="border border-main text-xs">
                                <tr class="bg-main text-white">
                                    <th scope="col" class="align-middle">N°</th>
                                    <th scope="col" class="align-middle">MONTO PAGADO</th>
                                    <th scope="col" class="align-middle" v-if="type == 'os'">TIPO</th>
                                    <th scope="col" class="align-middle">FECHA</th>
                                    <th scope="col" class="align-middle">USUARIO</th>
                                </tr>
                            </thead>
                            <tbody class="border border-main" style="font-size: 11px">
                                <tr class="tbody-table text-xs" v-for="(pay, index1) in bill.payments" :key="index1">
                                    <td class="align-middle">
                                        {{ index1 + 1 }}
                                    </td>
                                    <td class="align-middle">
                                        {{ pay.amount }}
                                    </td>
                                    <td class="align-middle" v-if="type == 'os'">
                                        {{ pay.type == 1 ? 'Pago Destraccion' : 'Pago del T. Neto' }}
                                    </td>
                                    <td class="align-middle">
                                        {{ pay.date }}
                                    </td>
                                    <td class="align-middle">
                                        {{ pay.user.name }}
                                    </td>
                                </tr>
                                <tr v-if="!data.length > 0" class="text-center">
                                    <th scope="col" colspan="4">NO HAY PAGOS REGISTRADOS</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        </div>
    </div>
</CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import CButtonClose from "../../shared/modals/cButtonClose.vue";
import moment from "moment";
import {
    mapActions
} from "vuex";

export default {
    name: "c-logistica-modals-report",
    components: {
        CModal,
        CButtonClose,
    },
    data() {
        return {
            filter: {
                date_start: "",
                date_end: "",
            },
            search: '',
            data: [],
            dataShow: [],
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 5,

        };
    },
    props: {
        title: String,
        type: String,
        boo_modal: Boolean,
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },

    },
    watch: {
        type: {
            handler(newVal) {
                // Realiza cualquier transformación necesaria en los datos aquí
                this.mtdShowData();
            },
            immediate: true // Para que se ejecute cuando el componente se monta por primera vez
        },
        selectPage() {
            this.calculateData(5);
        },
    },
    mounted() {
        this.getFirstDayOfMonth();
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdSearchFilter() {
            this.calculateData(5);
        },
        mtdShowData: function () {
            if (this.type !== '') {
                this.post({
                        url: this.$store.getters.get__url +
                            "/contabilidad/" + this.type + "/billPaymentReport",
                        token: this.$store.getters.get__token,
                        params: this.filter,
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.calculateData(5);
                    })
                    .catch((errors) => {});
            }

        },

        getFirstDayOfMonth: function () {
            const currentDate = new Date();
            const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
            this.filter.date_start = firstDayOfMonth.toISOString().split('T')[0];
            this.filter.date_end = lastDayOfMonth.toISOString().split('T')[0];
        },
        mtdclosemodal() {
            this.$emit('mtdCloseModalReporte')
        },
        calculateData(items) {
            if (!this.data) {
                this.dataShow = [];
            }
            let filteredData = this.data;
            let selectPage = this.selectPage;
            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = this.data.filter((element) => {
                    let number = element.number.toString().toUpperCase();
                    return number.includes(query);
                });
                selectPage = 1;
            }
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );
            let startIndex = (selectPage - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
        },
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function (index) {
            return (index + 1) + ((this.selectPage - 1) * 5);
        }

    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
    },
};
</script>
